angular.module('impactx.product').service('ProductImageGalleryService', [
    'dataGen',
    '$mdDialog',
    '$q',
    ProductImageGallery
]);

function ProductImageGallery(dataGen, $mdDialog, $q) {

    function openGallery(event, product) {
        if (product.isUnite) {
            if (product.imageUrl) {
                $mdDialog.show({
                    controller: 'ProductImageGalleryCtrl',
                    controllerAs: 'ctrl',
                    templateUrl: 'shared/displayelements/templates/product-image-gallery.html',
                    parent: angular.element(document.body),
                    targetEvent: event,
                    clickOutsideToClose: true,
                    hasBackdrop: false,
                    bindToController: true,
                    locals: {
                        product: product,
                        mediaList: [{url: product.imageUrl}]
                    }
                })
            }
        }
        else {
            getAllImages(product.id).then(function (response) {
                $mdDialog.show({
                    controller: 'ProductImageGalleryCtrl',
                    controllerAs: 'ctrl',
                    templateUrl: 'shared/displayelements/templates/product-image-gallery.html',
                    parent: angular.element(document.body),
                    targetEvent: event,
                    clickOutsideToClose: true,
                    hasBackdrop: false,
                    bindToController: true,
                    locals: {
                        product: product,
                        mediaList: impactX.isDefined(response, 'data.mediaList'),
                    }
                })
            });
        }
    }

    function getAllImages(proId) {
        return dataGen.getData({}, {proId: proId}, '/search/gallery');
    }

    function imageExists(url) {
        var defer = $q.defer();
        var img = new Image();

        img.onload = function () {
            defer.resolve();
        };
        img.onerror = function () {
            defer.reject();
        };
        img.src = url;

        return defer.promise;
    }

    return {
        openGallery: openGallery,
        imageExists: imageExists
    };
}